/**
 * Route for `cluster-analysis-group-level-anomaly`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClusterAnalysisGroupLevelAnomalyPage } from "../features/cluster-analysis-group-level-anomaly/ClusterAnalysisGroupLevelAnomalyPage";

export const clusterAnalysisGroupLevelAnomalyRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/cluster-analysis-group-level-anomaly",
	component: ClusterAnalysisGroupLevelAnomalyPage,
});

export default clusterAnalysisGroupLevelAnomalyRoute;
